import { InteractiveObject } from "../interactive-object.js";
/**
 * Represents interactive contour.
 */
export class InteractiveContour extends InteractiveObject {
    /** Empty constructor. */
    constructor(theViewer, theObjId = "") {
        super(theViewer, theObjId);
        if (this._myObjId === "") {
            this._myObjId = "_InteractiveContour";
        }
        this._myViewer.interactiveContourController.createContour(this._myObjId);
        this._myViewer.interactiveContext.displayObjectList(`${this._myObjId}`, false);
    }
    /** Make a copy of existing object with new id */
    clone() {
        return new InteractiveContour(this._myViewer, super._clone());
    }
    /** Add segment into contour. */
    addSegment(theSeg) {
        this._myViewer.interactiveContourController.addSegment(this._myObjId, theSeg);
    }
    /** Add array of segments into contour. */
    addSegments(theSegs) {
        // create a wrapper of c++ vector
        let aCppVec = new this._myViewer['VectorSegments'];
        for (let i = 0; i < theSegs.length; i++) {
            aCppVec.push_back(theSegs[i]);
        }
        //@ts-ignore
        this._myViewer.interactiveContourController.addSegments(this._myObjId, aCppVec);
        // free allocated memory
        aCppVec.delete();
    }
    /** Clear segments. */
    clearSegments() {
        this._myViewer.interactiveContourController.clearSegments(this._myObjId);
    }
    /** Return line width. */
    get lineWidth() {
        return this._myViewer.interactiveContourController.getLineWidth(this._myObjId);
    }
    /** Set line width. */
    set lineWidth(theWidth) {
        this._myViewer.interactiveContourController.setLineWidth(this._myObjId, theWidth);
    }
}
